import React, { useState } from "react";
import { Container, MenuContainer } from "./style";
import { Menu } from "../menu";
import { Link } from "react-router-dom";
export default () => {
  const [status, setStatus] = useState(false);
  return (
    <Container>
      <i
        title="راهنما"
        className={
          (status ? "pressed " : "") + "left-side-icon icon mapsa-question"
        }
        onClick={() => setStatus(!status)}
      />
      {status && (
        <Menu
          showMenu={status}
          close={() => setStatus(false)}
          
          leftPosition={150}
        >
          <MenuContainer>
            <li>
              <a
                href={localStorage.getItem("web_step_by_step")}
                target="_blank"
              >
                آموزش سریع
              </a>
            </li>
            <li>
              <Link to="/feedback">
                <span>پیام به پشتیبانی</span>
              </Link>
            </li>
          </MenuContainer>
        </Menu>
      )}
    </Container>
  );
};
